import { useOfferContext } from "@/lib/hooks/useOfferContext";
import {ProductFormContext} from "@/lib/product-form-context";
import {ProductComponent} from "@/components/ProductComponent";

export const OfferLayout = () => {
  const offer = useOfferContext();

  return (
    <div className="space-y-2">
      {Object.entries(offer.quotes).map(([product, productQuotes], index) => (
        <ProductFormContext.Provider value={index} key={index}>
          <ProductComponent product={product} productQuotes={productQuotes} />
        </ProductFormContext.Provider>
      ))}
    </div>
  )
}
